export const extractLastSegment = (input: string): string => {
  const segments = input.split('.');

  return segments[segments.length - 1];
};

export function openCreateProjectModal() {
  window.dispatchEvent(
    new CustomEvent('open-create-project-modal', {
      detail: {
        eventLocation: 'Digital sampling',
      },
    }),
  );
}
